import axios from 'axios';
//se for localhost, use o ip da sua maquina
//se for um servidor externo, use o ip do servidor

if(window.location.hostname === 'localhost') {
    axios.defaults.baseURL = 'http://localhost:21011/api/newsletter/';
} else {
    axios.defaults.baseURL = 'https://devfelipeborges.com.br/bupin/api/newsletter/';
}

export default axios;
